import React from 'react';
import { FormInstance } from 'antd/es/form';
import { AutoCompleteInput } from 'components/community/acceptance/components/AutoComplete';
import { communityAutoCompleteCompanyName } from 'libs/api/community';
import { CEmploymentType } from 'constants/community.const';
import { EEmploymentType } from 'enums/community.enum';
import { Form, Input, Select } from 'antd';
import styled from 'styled-components';
import { device } from 'GlobalStyles';

type TAboutCompanyProps = {
  form: FormInstance;
};

const CompanyNameAndEmploymentType = ({ form }: TAboutCompanyProps) => {
  return (
    <CompanyNameAndEmploymentTypeWrapper>
      <StyledCompanyNameContainer>
        <div>
          <div className='label'>기업명</div>
          <Form.Item
            className='form-item community-selector'
            name='company_name'
            rules={[{ required: true }]}
          >
            <AutoCompleteInput
              board='community'
              promise={communityAutoCompleteCompanyName}
              form={form}
              name={'company_name'}
            >
              <Input
                autoComplete='off'
                name='company_name'
                size='large'
                placeholder='회사명을 입력해주세요'
              />
            </AutoCompleteInput>
          </Form.Item>
          <Form.Item hidden style={{ width: '1px', height: '1px' }} name='company_name_id'>
            <Input name='company_id' />
          </Form.Item>
        </div>
      </StyledCompanyNameContainer>
      <StyledEmploymentTypeContainer>
        <div>
          <div className='label'>고용형태</div>
          <Form.Item
            className='form-item community-selector'
            name={'employment_type'}
            rules={[{ required: true }]}
          >
            <Select placeholder='고용형태 선택하기'>
              <Select.Option value={EEmploymentType.Newcomer}>
                {CEmploymentType[EEmploymentType.Newcomer]}
              </Select.Option>
              <Select.Option value={EEmploymentType.ExperiencedWorker}>
                {CEmploymentType[EEmploymentType.ExperiencedWorker]}
              </Select.Option>
              <Select.Option value={EEmploymentType.TransitionalTypeIntern}>
                {CEmploymentType[EEmploymentType.TransitionalTypeIntern]}
              </Select.Option>
            </Select>
          </Form.Item>
        </div>
      </StyledEmploymentTypeContainer>
    </CompanyNameAndEmploymentTypeWrapper>
  );
};

export default CompanyNameAndEmploymentType;

const CompanyNameAndEmploymentTypeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2px;

  @media screen and ${device.sm} {
    flex-direction: column;
  }
`;

const StyledCompanyNameContainer = styled.div`
  width: 49%;

  @media screen and ${device.sm} {
    width: 100%;
  }

  .label {
    margin-bottom: 7px;
  }

  input {
    border: none;
    background-color: #f9f9f9;
    outline: none;
  }
`;

const StyledEmploymentTypeContainer = styled.div`
  width: 49%;

  @media screen and ${device.sm} {
    width: 100%;
  }

  .label {
    margin-bottom: 7px;
  }
`;
